import { PostProperties } from "../types";
import image from "../img/lostGemSvreca.jpg";

const post: PostProperties = {
  id: 16,
  title: "Svreca - Unit, Tokyo (01.02.2013)",
  content:
    "Svreca, the establisher of Semantica label playing in Unit, Tokyo. Originally this mix was split into 3 different parts.",
  image,
  buttonText: "Listen Here",
  buttonUrl: "https://soundcloud.com/shubinproject/svreca-unit-tokyo-01022013",
  category: "Lost Gem",
  translationsBg: {
    content:
      "Svreca, основателят на лейбъл Semantica, застава зад пулта на Unit в Токио. Оригинално миксът е бил разделен на 3 отделни части.",
  },
};

export default post;
